import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebaseConfig.js";
import { showToast } from "../common-pages/toastServices.js";

// Function to request permission and get FCM token
export const requestNotificationPermission = async () => {
    try {

        const token = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY, });
        console.log("post token", token)
        if (token) {
            return token;
        } else {
            console.log("No registration token available. Request permission.");
        }
    } catch (error) {
        console.error("Error getting FCM token:", error);
    }
};

// Listen for Foreground Messages
export const onForegroundMessageListener = () => {
    onMessage(messaging, (payload) => {
        console.log("📩 Foreground message received:", payload);

        const { title, body } = payload.notification || {};
        const { link } = payload.fcmOptions || {};

        if (Notification.permission === "granted") {
            showToast(title, body, link, "success");
        } else {
            console.warn("Notifications are not allowed by the user.");
        };
    });
};
